import { Icon } from '@eventbrite/eds-icon';
import classNames from 'classnames';
import React from 'react';
import './SearchPivotAnchor.scss';

export const SearchPivotAnchor = ({
    href,
    text,
    containerClassNames = [],
    icon,
}: {
    href?: string;
    text?: any;
    containerClassNames?: string[];
    icon?: any;
}) => {
    const searchPivotAnchorClasses = classNames(
        'search-pivot-anchor',
        'eds-align--center',
        ...containerClassNames,
    );

    return (
        <div
            className={searchPivotAnchorClasses}
            data-testid="search-pivot-anchor"
        >
            <a href={href} className="eds-text-weight--heavy eds-align--center">
                {icon && (
                    <span className="eds-l-mar-right-3">
                        <Icon type={icon} />
                    </span>
                )}
                {text}
            </a>
        </div>
    );
};
